<template>
  <div id="userApps">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="body">
        <h4>연결목록</h4>
        <div class="table-responsive">
          <table class="table" id="appsTabl">
            <thead>
            <tr>
              <th>#</th>
              <th>#</th>
              <th>연결명</th>
              <th>생성일</th>
              <th></th>
            </tr>
            </thead>
            <tbody v-if="conList.length != 0">
            <tr v-for="(con, index) in conList" :key="index">
              <td>{{index + 1}}</td>
              <td>
                <span class="size" title="small" style="margin-right: 5px">
                  <img
                    class="workIcon w60 rounded" alt="Rounded Image"
                    :src="imagePaths(con.appImage)"
                  />
                </span>
              </td>
              <td>{{ con.connectionName }} (버전 : {{con.versionCode}})</td>
              <td>{{ con.insertDt }}</td>
              <td><button class="btn btn-warning" @click="deleteConnection(index)">삭제</button></td>
            </tr>
            </tbody>
            <tbody v-else>
            <td colspan="5">연결 기록이 없습니다.</td>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'ConnectionPage',
  components: {
  },
  data() {
    return {
      conList : [],
      appCode : '',
    }
  },
  methods: {
    deleteConnection(index) {

      if(confirm("삭제하시겠습니까? 연결이 되어있는 경우 정상동작을 안할 수 있습니다.")){
        var selectedConn = this.conList[index];

        var param = { connectionCode: selectedConn.connectionCode, userCode: this.userStore.userCode, appCode: this.appCode, versionCode : selectedConn.versionCode };
        this.api.deleteConnection(param).then((res) => {
          console.log("deleteConnection res : ", res);
          if (res["code"] == 0) {

            // this.$store.dispatch("saveConnections", res.connections);
            // this.conList = res.connections;

            this.conList.splice(index, 1);

          }
        });

      }

    },
    imagePaths(value) {
      if (value != null && value != "") {
        return (
          "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/" +
          value
        );
      } else {
        return "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/common/noimage.jpg";
      }
    },
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    userStore() {
      return this.$store.state.userStore;
    }
  },
  created() {
    console.log('ConnectionPage created')
    var connlist = [];

    console.log(this.$route.params.workflowCode)
    var workflowCode = this.$route.params.workflowCode

    // var param = {workflowCode : workflowCode}
    this.api.getWorkflowDetail({workflowCode : workflowCode})
      .then((res)=>{

        console.log(res)

        var apis = JSON.parse(res.workflow.workflowSchema).workflows;

        var pastCodes = [];

        console.log(apis)
        var lists = []

        for(var i = 0; i < apis.length; i++){
          if(apis[i].api.appCode != undefined && apis[i].api.appCode != "" && (pastCodes.toString().indexOf(apis[i].api.appCode) == -1)){
            pastCodes.push(apis[i].api.appCode)
            this.appCode = apis[i].api.appCode;

            console.log(pastCodes)

            var param = { userCode: this.$store.state.userStore.userCode, appCode : apis[i].api.appCode, versionCode : apis[i].api.versionCode };
            this.api.getConnectionList(param).then((res) => {

              console.log("getConnectionList : ", res)

              for(var j = 0; j < res.connections.length; j++){
                lists.push(res.connections[j])
              }
              // this.conList = res.connections;

              console.log("connlist : ", connlist)
            })
          }
        }
        this.conList = lists;
      })
  },
  mounted() {
    console.log('ConnectionPage created')
  },
  beforeDestroy() {
    console.log('ConnectionPage beforeDestroy')
  }
}
</script>
<style scoped>
#userApps {
  padding: 10px;
}

#appsTabl {
  text-align: center;
}
</style>
